import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import {
  Field,
  reduxForm,
  formValueSelector,
  getFormSyncErrors,
  getFormMeta,
} from "redux-form";
import {
  firstName,
  lastName,
  email,
  validatePassword,
  confirmPassword,
  getPasswordFieldsPassed,
  address,
  city,
  state,
  zip,
  phone,
} from "../validation";
import RenderFormField from "./renderFormField.jsx";
import RenderStateDropdown from "./renderStateDropdown.jsx";
import { ALL_STATES } from "../../../constants/payfields";
import { PrimaryButton } from "../../../modules/Button";

const passwordFieldClasses = (value) => {
  return classNames("col-md-6 password-requirement", {
    "field-invalid": value === false,
    "field-valid": value === true,
  });
};
const passwordSymbolClasses = (value) => {
  return classNames("fa fa-lg mar-r-10 password-symbol", {
    "fa-times": value === false,
    "fa-check": value === true,
  });
};

const SignUp = ({
  password,
  passwordFields,
  createAccount,
  userInfo,
  handleSubmit,
}) => {
  const submit = handleSubmit(createAccount);
  const { password: { active } = {} } = passwordFields;
  const {
    lowerCasePass,
    upperCasePass,
    lengthPass,
    numberPass,
    specialCharacterPass,
  } = getPasswordFieldsPassed(password);
  const submissionClasses = classNames("blue-btn mar-b-10", {
    "darken-btn-bg": userInfo.get("displayLoading"),
  });
  return (
    <form onSubmit={submit}>
      <div className="row">
        <div className="col-sm-6 pad-r-5 mar-b-10">
          <Field
            name="firstname"
            label="firstname"
            component={RenderFormField}
            type="text"
            placeholder="First Name"
            className="cc-input"
            validate={firstName}
          />
        </div>
        <div className="col-sm-6 pad-l-5 mar-b-10">
          <Field
            name="lastname"
            label="lastname"
            component={RenderFormField}
            type="text"
            placeholder="Last Name"
            className="cc-input"
            validate={lastName}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 mar-b-10 pad-5-sm">
          <Field
            name="email"
            label="email"
            component={RenderFormField}
            type="text"
            placeholder="Email"
            className="cc-input"
            validate={email}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 pad-r-5 mar-b-10">
          <Field
            name="password"
            label="password"
            component={RenderFormField}
            type="password"
            placeholder="Password"
            className="cc-input"
            validate={validatePassword}
          />
        </div>
        <div className="col-sm-6 pad-l-5 mar-b-10">
          <Field
            name="confirmPassword"
            label="confirmPassword"
            component={RenderFormField}
            type="password"
            placeholder="Confirm Password"
            className="cc-input"
            validate={confirmPassword}
          />
        </div>
      </div>
      {active && (
        <div className="mar-b-15">
          <div className="row">
            <div className="col-md-12">
              <div className="font-12pt" style={{ color: "#7f7f7f" }}>
                Password must contain the following:
              </div>
            </div>
          </div>
          <div className="row">
            <div className={passwordFieldClasses(lowerCasePass)}>
              <i className={passwordSymbolClasses(lowerCasePass)} />
              <div>A lowercase letter</div>
            </div>
            <div className={passwordFieldClasses(upperCasePass)}>
              <i className={passwordSymbolClasses(upperCasePass)} />
              <div>An uppercase letter</div>
            </div>
          </div>
          <div className="row">
            <div className={passwordFieldClasses(numberPass)}>
              <i className={passwordSymbolClasses(numberPass)} />
              <div>A number</div>
            </div>
            <div className={passwordFieldClasses(lengthPass)}>
              <i className={passwordSymbolClasses(lengthPass)} />
              <div>Minimum 8 characters</div>
            </div>
          </div>
          <div className="row">
            <div
              className={
                "col-md-12 " + passwordFieldClasses(specialCharacterPass)
              }
            >
              <i className={passwordSymbolClasses(specialCharacterPass)} />
              <div>A special character: @$!%*?&</div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-sm-12 mar-b-10 pad-5-sm">
          <Field
            name="address"
            label="address"
            component={RenderFormField}
            type="text"
            placeholder="Address Line 1 - Street Address"
            className="cc-input"
            validate={address}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 mar-b-10 pad-5-sm">
          <Field
            name="address2"
            label="address2"
            component={RenderFormField}
            type="text"
            placeholder="Address Line 2 - Apartment, Suite, Floor (optional)"
            className="cc-input"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 pad-r-5 mar-b-10">
          <Field
            name="city"
            label="city"
            component={RenderFormField}
            type="text"
            placeholder="City"
            className="cc-input"
            validate={city}
          />
        </div>
        <div className="col-sm-6 pad-l-5 mar-b-10">
          <Field
            name="state"
            label="state"
            component={RenderStateDropdown}
            type="text"
            placeholder="Select State"
            className="cc-input"
            validate={state}
            list={ALL_STATES}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 pad-r-5 mar-b-10">
          <Field
            name="zip"
            label="zip"
            component={RenderFormField}
            type="text"
            placeholder="Zip"
            className="cc-input"
            validate={zip}
          />
        </div>
        <div className="col-sm-6 pad-l-5 mar-b-10">
          <Field
            name="phone"
            label="phone"
            component={RenderFormField}
            type="text"
            placeholder="Phone"
            className="cc-input"
            validate={phone}
          />
        </div>
      </div>
      <div className="row mar-b-10">
        <div className="col-sm-12 pad-5-sm">
          <PrimaryButton disabled={!!userInfo.get("displayLoading")}>
            {userInfo.get("displayLoading") ? (
              <div className="loadersmall" />
            ) : (
              "Complete Sign Up"
            )}
          </PrimaryButton>
        </div>
      </div>
    </form>
  );
};

export default connect((state) => {
  const password = formValueSelector("signUp")(state, "password");
  const passwordErrors = getFormSyncErrors("signUp")(state, "password");
  const passwordFields = getFormMeta("signUp")(state, "password");
  const userInfo = state.userInfo;
  return { password, passwordErrors, passwordFields, userInfo };
})(
  reduxForm({
    form: "signUp",
    enableReinitialize: true,
  })(SignUp)
);
